import { Route, RouteProps, Redirect } from "react-router";
import { GetCookie } from "./Utils/AppFunc";
export const AppRoute = ({ component: Component, layout: Layout, path: Path, ...rest }) => {

    var loggedInUser = GetCookie("user");
    console.log("loged user...approute...", loggedInUser);
    if (loggedInUser == "" || !loggedInUser) {
		localStorage.clear();
    }

    return <Route {...rest} render={props => (
        <Layout>
            <Component {...props} />
        </Layout>
    )} />;
}